import getCurrentUserLicenseStatus from './getCurrentUserLicenseStatus';
import {getFeatureFlagStatus} from 'client/components/FeatureFlag/featureFlag.utils';
import {history} from 'client/history';
import {local} from 'lib/StorageUtil';
import sessionStore from 'client/Session/SessionStore';
import {UserLicenseStatus} from 'gql/types';

export async function redirect({location} = {}) {
  let target = null;

  if (local.get('postLoginRedirect')) {
    history.pushState(null, local.get('postLoginRedirect'));
    return;
  }

  if (location) {
    target = getLocationRedirectTarget(location.query);
  }

  if (target) {
    history.pushState(null, target);
  } else if (sessionStore.hasValidSession()) {
    /**
     * If the user is logged in, we redirect them to their user type's
     * default page.
     */
    history.pushState(null, await getUserTypeRedirectTarget());
  } else {
    /**
     * The default case is to take a user home.
     *
     * This is tripped if a user is
     * 1. logged out
     * 2. no `location` is provided
     */
    global.document.location = '/';
  }
}

function getLocationRedirectTarget(query) {
  if (query && query.classroomId && query.classroomInvitationId) {
    return `/classes?classroomId=${query.classroomId}&classroomInvitationId=${query.classroomInvitationId}`;
  }

  return null;
}

export async function getUserTypeRedirectTarget() {
  if (sessionStore.isSuper()) {
    return '/dennis';
  }

  if (sessionStore.isContentManager()) {
    return '/dennis/content';
  }

  if (sessionStore.isAuthor()) {
    return '/dennis/content/dashboard';
  }
  /**
   * Teachers always go to `/classes`
   */
  if (sessionStore.isTeacher()) {
    return '/classes';
  }

  // Retail students go to `/my-data`
  const currentUserLicenseStatus = await getCurrentUserLicenseStatus();
  if (currentUserLicenseStatus === UserLicenseStatus.Retail) {
    return '/my-data';
  }

  /**
   * For any other user type (students), we redirect them to `/classes` or `/home`
   * depending on the state of the `new_student_dashboard` feature flag.
   */
  const isNewStudentDashboardEnabled = await getFeatureFlagStatus('new_student_dashboard');
  return isNewStudentDashboardEnabled ? '/home' : '/classes';
}

export function shouldRedirectFromPathname(pathname) {
  const redirectPaths = ['/forgot-password', '/reset-password', '/signup', '/social'];
  return (
    pathname === '/' ||
    redirectPaths.some((path) => path === pathname) ||
    (pathname.startsWith('/dennis') && !sessionStore.hasAuthorAccess()) || // non dennis user trying to access dennis routes. This is needed to redirect non dennis users away from dennis
    (pathname.startsWith('/dennis') &&
      !pathname.startsWith('/dennis/content') &&
      !sessionStore.isSuper()) // non super users only have access to content routes in Dennis (authors, content managers). This is needed to redirect authors and content managers back to the content
  );
}
